ginkgo = {
    // Validación CUIT
    validarCuit: function (raw_cuit) {

        if(!raw_cuit)
            return false

        let cuit = raw_cuit.replace(/-/g, '')
        if (cuit.length != 11) {
            return false;
        }

        var acumulado = 0;
        var digitos = cuit.split("");
        var digito = digitos.pop();

        for (var i = 0; i < digitos.length; i++) {
            acumulado += digitos[9 - i] * (2 + (i % 6));
        }

        var verif = 11 - (acumulado % 11);
        if (verif == 11) {
            verif = 0;
        }
        return digito == verif;
    },
    //ajaxStatus es OK o Error
    showNotificationToast: function(ajaxStatus, message){
        var toastElem = $('#gk-ajax-messages-toast');
        toastElem.css('display','block')
        if(ajaxStatus=='ok' || ajaxStatus=='OK'){
            toastElem.find('i').addClass('text-success fa-check-circle');
            toastElem.find('.toast-body').addClass('alert-success');
        }
        else if(ajaxStatus=='error' || ajaxStatus=='ERROR'){
            toastElem.find('i').addClass('text-danger fa-exclamation-triangle');
            toastElem.find('.toast-body').addClass('alert-danger');
        }
        toastElem.find('.toast-body').text(message);
        toastElem.toast('show');

    },
    initToasts: function(){
        var myToastEl = $('#gk-ajax-messages-toast')
        myToastEl.on('show.bs.toast', function () {
            myToastEl.parent().css('display','block')
        })
        myToastEl.on('hidden.bs.toast', function () {
            myToastEl.parent().css('display','none')
        })
        var myToastEl2 = $('#gk-system-messages-toast')
        if(myToastEl2){
            myToastEl2.on('show.bs.toast', function () {
                myToastEl2.parent().css('display','block')
            })
            myToastEl2.on('hidden.bs.toast', function () {
                myToastEl2.parent().css('display','none')
            })
        }
    },
    autogestionEmpresas: {
        addEventListeners: function(formObj){

            $(formObj).find("input[name=email]").on('change',this.emailOnChangeHandler);
            $(formObj).find("input[name=cuil]").on('focusout',this.cuilOnFocusoutHandler);       
            
            //Cleaves initialization => DNI
            new Cleave($(formObj).find("input[name=dni]"), {
                numericOnly: true,
                blocks: [10]
            });
            //Cleaves initialization => CUIL
            new Cleave($(formObj).find("input[name=cuil]"), {
                blocks: [2, 8, 1],
                delimiter: '-',
                delimiterLazyShow: true,
                numericOnly: true
            });
            $(formObj).on("submit",function(){
                $(this).find('input[name=email_conf]').trigger('keyup')
            });

        },
        emailOnChangeHandler: function(){
            $(this).parents('form').find('input[name=email_conf]').on('keyup', function () {
                'use strict';
                if ($(this).parents('form').find('input[name=email]').val() === $(this).val()) {
                    $(this).next('.invalid-feedback').hide();
                    this.setCustomValidity('');
                } else {
                    $(this).next('.invalid-feedback').show();
                    this.setCustomValidity('Email no concuerda');
                }
            });
        },
        cuilOnFocusoutHandler: function (){
            'use strict';
            if (!ginkgo.validarCuit($(this).val().replace(/-/g, ''))) {
                $(this).next('.invalid-feedback').show();
                return;
            }
            else {
                $(this).next('.invalid-feedback').hide();
                this.setCustomValidity('');
                ginkgo.autogestionEmpresas.autoSetDNI($(this));
            }
        },
        deleteResHandler: function (event, nombre) {
            if (window.confirm("Estás seguro de querer desvincular al responsable de la empresa?")) {
                document.location = url;
            }
            else
                event.preventDefault();
        },
        autoSetDNI: function(cuilObj){
            //Autocompletado del campo de DNI
            $(cuilObj).parents('form').find('input[name=dni]').val(function(){
                //Tomo el dato del CUIL
                let cuil_pieces = $(cuilObj).val().split('-');
                // Asigno al DNI el valor del medio de los guiones de CUIL
                if(cuil_pieces.length > 1){
                    return cuil_pieces[1];	
                }
            });
        }
    }
}

ginkgo.initToasts()